import styled from "styled-components";

export const Wrap = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
`;
export const Text = styled.span`
  font-family: Poppins;
  font-size: 16px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 24px;
  letter-spacing: -0.41px;
  text-align: center;
  color: #242424;
  @media screen and (max-width: 1240px) {
    font-size: 14px;
  }
`;

export const ResendText = styled.button`
  color: #536eb7;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  @media screen and (max-width: 1240px) {
    font-size: 14px;
  }
`;
